/**
 * One playlist's records.
 *
 * The way back is drawn outside the boundaries, so it is there to press while
 * the tracks are still loading and still there if they never arrive.
 */

import { useQuery } from '@tanstack/solid-query';
import { type Component, Errored, Loading, Show } from 'solid-js';
import { showLibrary } from '../../app/browse.ts';
import { messageOf } from '../../app/playback.ts';
import { playlistTracksQuery } from '../../app/queries.ts';
import type { Playlist } from '../../types/media.ts';
import { BackRow, Empty, Spinner } from './SheetStates.tsx';
import { TrackList } from './TrackList.tsx';

export interface PlaylistPanelProps {
  playlist: Playlist;
}

const Tracks: Component<PlaylistPanelProps> = (props) => {
  const query = useQuery(() => playlistTracksQuery(props.playlist));
  return (
    <Show
      when={query.data.length}
      fallback={<Empty title="Empty playlist" body="Nothing playable in here." />}
    >
      <TrackList tracks={query.data} header={`${query.data.length} tracks`} />
    </Show>
  );
};

export const PlaylistPanel: Component<PlaylistPanelProps> = (props) => (
  <>
    <BackRow label="Library" onClick={showLibrary} />
    <Loading fallback={<Spinner />}>
      <Errored
        fallback={(err) => (
          <Empty title="Could not open that" body={messageOf(err(), 'Try again in a moment.')} />
        )}
      >
        <Tracks playlist={props.playlist} />
      </Errored>
    </Loading>
  </>
);
